<!--
  - @copyright 2023 Christopher Ng <chrng8@gmail.com>
  -
  - @author Christopher Ng <chrng8@gmail.com>
  -
  - @license AGPL-3.0-or-later
  -
  - This program is free software: you can redistribute it and/or modify
  - it under the terms of the GNU Affero General Public License as
  - published by the Free Software Foundation, either version 3 of the
  - License, or (at your option) any later version.
  -
  - This program is distributed in the hope that it will be useful,
  - but WITHOUT ANY WARRANTY; without even the implied warranty of
  - MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  - GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program. If not, see <http://www.gnu.org/licenses/>.
  -
-->

<template>
	<div v-if="privacyPolicyUrl"
		class="privacy">
		<h3>{{ t('privacy', 'Privacy policy') }}</h3>

		<a class="privacy__link"
			target="_blank"
			rel="noreferrer noopener"
			:href="privacyPolicyUrl">
			{{ t('privacy', 'Read the privacy policy ↗') }}
		</a>
	</div>
</template>

<script>
import { loadState } from '@nextcloud/initial-state'

export default {
	name: 'Privacy',

	inject: [
		't',
	],

	data() {
		return {
			privacyPolicyUrl: loadState('privacy', 'privacyPolicyUrl'),
		}
	},
}
</script>

<style lang="scss" scoped>
.privacy {
	&__link {
		text-decoration: underline;
	}
}
</style>
